import React from 'react';
import { FormControl, Select, MenuItem } from '@mui/material';
import { styled } from '@mui/material/styles';
import { useTheme } from '../../../../ThemeContext';

const StyledFormControl = styled(FormControl)(({ theme }) => ({
  marginBottom: '12px',
  '&:last-child': {
    marginBottom: 0,
  },
  '& .MuiOutlinedInput-root': {
    backgroundColor: '#3e3c56',
    borderRadius: '8px',
    color: '#ffffff',
    height: '48px',
    '& fieldset': {
      border: 'none',
    },
    '&:hover': {
      backgroundColor: '#4a485f',
    },
    '&.Mui-focused': {
      backgroundColor: '#4a485f',
    },
  },
  '& .MuiSelect-icon': {
    color: 'rgba(255, 255, 255, 0.7)',
  },
}));

const StyledSelect = styled(Select)(({ theme }) => ({
  '& .MuiSelect-select': {
    padding: '12px 15px',
    '&.MuiInputBase-input': {
      color: 'rgba(255, 255, 255, 0.5)',
      fontSize: '16px',
    },
  },
}));

const BaseDropdown = ({
  options,
  value,
  onChange,
  placeholder = 'Select an option',
  loading = false,
  error = null,
  disabled = false,
  fullWidth = true,
}) => {
  const { themeMode } = useTheme();

  return (
    <StyledFormControl
      variant="outlined"
      fullWidth={fullWidth}
      error={!!error}
      disabled={disabled || loading}
    >
      <StyledSelect
        value={value || ''}
        onChange={onChange}
        displayEmpty
        MenuProps={{
          PaperProps: {
            sx: {
              backgroundColor: '#3e3c56',
              boxShadow: '0px 5px 15px rgba(0, 0, 0, 0.3)',
              marginTop: '4px',
              '& .MuiMenuItem-root': {
                padding: '12px 16px',
                color: '#ffffff',
                fontSize: '16px',
                '&:hover': {
                  backgroundColor: '#4a485f',
                },
                '&.Mui-selected': {
                  backgroundColor: '#4a485f',
                  '&:hover': {
                    backgroundColor: '#57556a',
                  },
                },
              },
            },
          },
        }}
        renderValue={(selected) => {
          if (!selected) {
            return <span style={{ color: 'rgba(255, 255, 255, 0.5)' }}>{placeholder}</span>;
          }
          return <span style={{ color: '#ffffff' }}>{selected}</span>;
        }}
      >
        {options.map((option) => (
          <MenuItem key={option} value={option}>
            {option}
          </MenuItem>
        ))}
      </StyledSelect>
    </StyledFormControl>
  );
};

export default BaseDropdown; 